export default __webpack_public_path__ + "static/media/3B.a6ce77d7.png";